module.exports = __webpack_public_path__ + "static/media/pera_big.c7f3d9e8.png";